import { Box } from '@mui/material';
import { PublicOutlined } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

import { LIBRARY_PAGE_LAYOUT_SIZES } from '../libraryTokens';

export function LibraryPlatformIcon(): JSX.Element {
  const theme = useTheme();
  const iconSize = LIBRARY_PAGE_LAYOUT_SIZES.platformIconInnerSize;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: LIBRARY_PAGE_LAYOUT_SIZES.platformIconSize,
        height: LIBRARY_PAGE_LAYOUT_SIZES.platformIconSize,
        borderRadius: `${LIBRARY_PAGE_LAYOUT_SIZES.platformIconRadius}px`,
        bgcolor: theme.palette.library.platformIconBackground,
        color: theme.palette.text.primary,
        flexShrink: 0,
      }}
      aria-hidden
    >
      <PublicOutlined sx={{ fontSize: iconSize }} />
    </Box>
  );
}
